'use client';
import { useEffect, useState } from 'react';
import { User } from '@/types/spExportableSchema';
import { spClient } from '@/utils/supabase/client';
import { Session } from '@supabase/supabase-js';
import {createContext} from 'react';

export default function AuthProvider({children}: {children: React.ReactNode}) {
	const [session, setSession] = useState<Session | null>(null);
	const [currentUser, setCurrentUser] = useState<User | null>(null);

	useEffect(() => {
		spClient.auth.getSession().then(({data: {session}}) => {
			setSession(session);
		});

		const subscription = spClient.auth.onAuthStateChange((event, session) => {
			if (event === 'SIGNED_OUT') {
				setSession(null);
				setCurrentUser(null);
			} else if (event === 'SIGNED_IN') {
				setSession(session);
			} 
			else if (session) {
				setSession(session);
				setCurrentUser(null);
			}
		});

		return () => {
			subscription.data.subscription.unsubscribe();
		}
	}, []);
	
	useEffect(() => {
		if (session?.user && !currentUser) {
			getUser();
		}
	}, [session]);

	async function getUser() {
		const {data: user, error} = await spClient
			.from('users')
			.select('*')
			.eq('user_uid', session!.user.id)
			.single();

		if (error) {
			console.error("Error gettin user", error)
			throw error;
		}

		setCurrentUser(user as User);
	}

	return (
		<AuthContext.Provider value={{ session }}>
			{children}
		</AuthContext.Provider>
	)
}

export const AuthContext = createContext<{ session : Session | null }>({ session: null });
